import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';
import ChatBot from '../components/ChatBot';
import './ContactPage.css';

export default function ContactPage() {
  return (
    <>
      <div className="contact-page-wrapper">
        <Header />
        <div className="contact-page-content">
          <ContactSection />
        </div>
        <ChatBot />
      </div>
      <Footer />
    </>
  );
}
